<template>
    <ManualSection :header="header" :open="open" @click="$emit('click')" :state="(baseDataFilled && passportDataFilled) ? 'success' : 'danger'">
        <UserData :show-header="false" :small-edit-button="true" />
        <UserPassport :show-header="false" :small-edit-button="true" />
        <template v-slot:comment>
            <p class="cmnt" v-if="verified">✓ Паспортные данные проверены.</p>
            <template v-if="(baseDataFilled && passportDataFilled) && !open">
                <p class="dataPreview cmnt">{{ userDataString }}</p>
                <p class="dataPreview cmnt">{{ dateOfBirth }}</p>
                <p class="dataPreview cmnt">{{ userPassportDataString }}</p>
            </template>
        </template>
    </ManualSection>
</template>

<script>
import UserData from '@/components/UserData.vue'
import UserPassport from '@/components/UserPassport.vue'
import ManualSection from '@/components/ManualSection.vue'
import { convertYMDtoDMY } from '@/utils/convertor.js'

export default {
    props: {
        header: String,
        open: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        ManualSection,
        UserData,
        UserPassport,
    },
    computed: {
        passportDataFilled() {
            return this.$store.getters.isUserPassportDataFilled
        },
        baseDataFilled() {
            return this.$store.getters.isUserDataFilled
        },
        userDataString() {
            return this.$store.getters.userDataString
        },
        userPassportDataString() {
            return this.$store.getters.userPassportDataString
        },
        dateOfBirth() {
            return convertYMDtoDMY(this.$store.getters.getUserData.memberInfo?.birthdate || '');
        },
        verified() {
            return this.$store.getters.getUserData.memberInfo?.isPassportDataVerified;
        },
    }
}
</script>
